module.exports = __webpack_public_path__ + "static/media/jenga.c8aff00a.svg";